import { setLocaleWithFallback } from "../../../actions";
import { ContentMap } from "../../config/contentMap";
import throwError, { toastPartnerApiFailure } from "../../../comps/errorToast";
import React from "react";
import { isRestrictedSanctionCountry } from "../../../utils/restrictedSanctionCountry";

// TODO(sanctions-ru-by): RU/BY Next-step block — controlled by SANCTIONS_RU_BY_VALIDATION_ENABLED
const RESTRICTED_ENROLMENT_MESSAGE = (
  <span>
    Please note that we are not accepting any new enrolments for Russia and
    Belarus location.
    <br />
    <br />
    Best regards,
    <br />
    APC Team
  </span>
);

let g_prop;

/*********************************
 * Configuration and Common Method
 *********************************/
// UI VS Server mapping
const fieldSetupForServer = {
  dataForUpsertAccount: [
    "name",
    "companyPhone",
    "fax",
    "billingStreet",
    "billingCity",
    "billingState",
    "billingCountry",
    "billingPostalCode",
    "tradingName",
    "bizRegistrationNum",
    "preferredDistributor",
    "dateFounded",
    "companyType",
    "companyEmail",
    "primaryUrl",
    "secondaryUrl",
    "preferredLanguage_0",
  ],
  multiSelects: ["companyType"],
  dataForAccountId: "accountId",
  dataForStage1PreferredLanguage: "preferredLanguage_0",
};

// COMMON creation of body.
const createBody = (action) => {
  let body = {};
  fieldSetupForServer[action].forEach((field) => {
    if (field in g_prop.registration) {
      if (typeof field == "object") {
        for (var key in field) {
          body[field[key]] = g_prop.registration[key];
        }
      } else {
        if (fieldSetupForServer.multiSelects.includes(field)) {
          body[field] = g_prop.registration[field].join(";");
        } else if (field === "preferredLanguage_0") {
          body["preferredLanguage"] = g_prop.registration[field];
        } else {
          body[field] = g_prop.registration[field];
        }
      }
    }
  });
  return body;
};
/*********************************
 * END - Configuration and Common Method
 *********************************/

/*********************************
 * SERVER calls from buttons
 *********************************/
// Create/update Partner
export const upsertAccount = (prop) => {
  g_prop = { ...prop };
  let body = createBody("dataForUpsertAccount");
  if (
    g_prop.btnLabel === "Register" &&
    g_prop.registration[fieldSetupForServer.dataForAccountId]
  ) {
    prop.is_saving(true);
    prop.connector.updatePartner(
      onAccountSavePending,
      g_prop.registration[fieldSetupForServer.dataForAccountId],
      {},
      { action: "Submit" },
    );
  } else if (g_prop.registration[fieldSetupForServer.dataForAccountId]) {
    // Update Partner on 3rd stage
    // TO BE UPDATED - use onAccountSavePending in callback
    prop.is_saving(true);
    prop.connector.updatePartner(
      onAccountSavePending,
      g_prop.registration[fieldSetupForServer.dataForAccountId],
      body,
    );
  } else {
    // Create Partner on 3rd stage
    // TO BE UPDATED - use onAccountSavePending in callback
    prop.is_saving(true);
    prop.connector.createPartner(onAccountSavePending, body);
  }
};
/*********************************
 * END -SERVER calls from buttons
 *********************************/

/*********************************
 * GENERAL calls from buttons
 *********************************/
// set locale and go next
export const setLocaleOnNext = (prop) => {
  // Send language code from preferred language selected from Stage 1.
  prop.setLocaleAction(
    ContentMap.languageNameCode[
      prop.registration[fieldSetupForServer.dataForStage1PreferredLanguage]
    ],
  );

  if (isRestrictedSanctionCountry(prop.registration.billingCountry)) {
    throwError(RESTRICTED_ENROLMENT_MESSAGE);
  } else {
    prop.allbuttonFunc.onNextButton();
  }
};

export const upsertContact = (prop) => {
  g_prop = { ...prop };
  let body_1 = {};
  let body_0 = {};
  if (!g_prop.registration.contactId_1) {
    body_1 = {
      firstName: g_prop.registration.firstName_1,
      lastName: g_prop.registration.lastName_1,
      prefix: g_prop.registration.prefix_1,
      suffix: g_prop.registration.suffix_1,
      email: g_prop.registration.email_1,
      phone: g_prop.registration.phone_1,
      preferredLanguage: g_prop.registration.preferredLanguage_1,
      jobRole: g_prop.registration.jobRole_1,
      mainContactType: "Secondary",
      additionalContactType:
        g_prop.registration.additionalContactType_1.join(";"),
    };
  } else {
    body_1 = {
      phone: g_prop.registration.phone_1,
      preferredLanguage: g_prop.registration.preferredLanguage_1,
      prefix: g_prop.registration.prefix_1,
      suffix: g_prop.registration.suffix_1,
      jobRole: g_prop.registration.jobRole_1,
      additionalContactType:
        g_prop.registration.additionalContactType_1.join(";"),
      mainContactType: "Secondary",
    };
  }

  body_0 = {
    phone: g_prop.registration.phone_0,
    preferredLanguage: g_prop.registration.preferredLanguage_0,
    prefix: g_prop.registration.prefix_0,
    suffix: g_prop.registration.suffix_0,
    jobRole: g_prop.registration.jobRole_0,
    additionalContactType:
      g_prop.registration.additionalContactType_0.join(";"),
    mainContactType: "Primary",
  };
  prop.is_saving(true);
  prop.connector.upsertPrimaryAndSecondary(
    onContactSaveComplete,
    body_0,
    g_prop.registration.contactId_0,
    body_1,
    g_prop.registration.contactId_1,
  );
};

// Return from Save and Exit
export const rtrnSaveNExt = () => {
  g_prop.onClkSaveAndExit(false);
};
/*********************************
 * End - General calls from buttons
 *********************************/

/*********************************
 * Callback
 *********************************/
const onContactSaveComplete = (response_0, response_1 = {}) => {
  let isError = false;
  if (response_0 && Object.keys(response_0)?.length > 0) {
    if (Boolean(response_0.contactId)) {
      g_prop.change("contactId_0", response_0.contactId);
    } else {
      toastPartnerApiFailure(response_0);
      isError = true;
    }
  }

  if (response_1 && Object.keys(response_1)?.length > 0 && !isError) {
    if (Boolean(response_1.contactId)) {
      g_prop.change("contactId_1", response_1.contactId);
    } else {
      toastPartnerApiFailure(response_1);
      isError = true;
    }
  }

  g_prop.is_saving(false);

  if (!isError) {
    if (g_prop.btnLabel === "Next") {
      g_prop.allbuttonFunc.onNextButton();
    } else {
      g_prop.onClkSaveAndExit(true);
    }
  }
};

const onAccountSavePending = (response) => {
  if (response?.saveInProgress === true) {
    setTimeout(
      g_prop.connector.statusCheck,
      3000,
      onAccountSavePending,
      response?.statusUrl,
    );
  } else {
    onAccountSaveComplete(response);
  }
};

const onAccountSaveComplete = (response) => {
  g_prop.is_saving(false);
  if (
    response?.isError ||
    !Boolean(response?.accountId) ||
    !Boolean(response?.contactId)
  ) {
    toastPartnerApiFailure(response);
  } else {
    g_prop.change("contactId_0", response?.contactId);
    g_prop.change("accountId", response?.accountId);
    if (g_prop.btnLabel === "Next" || g_prop.btnLabel === "Register") {
      g_prop.allbuttonFunc.onNextButton();
    } else if (g_prop.btnLabel === "Save and Exit") {
      g_prop.onClkSaveAndExit(true);
    }
  }
};
